export enum Role {
  Admin = 'admin',
  Agency = 'agency',
  Customer = 'customer',
  User = 'User'
}
